import Constants from 'expo-constants';
import React, { useEffect } from 'react';
import { Platform } from 'react-native';

import { useAnalyticsConsent } from '@/hooks/use-analytics-consent';

// Requests ATT on iOS once per install if privacy label indicates tracking.
// Renders nothing; place near app root before analytics events fire.
export const ATTConsentGate: React.FC = () => {
	const { consent, requestConsent } = useAnalyticsConsent();

	useEffect(() => {
		// Only try once if unknown; skip on non-iOS or Expo Go
		const isNativeClient = Constants.appOwnership !== 'expo';
		if (Platform.OS === 'ios' && isNativeClient && consent === 'unknown') {
			console.log('ATTConsentGate: Requesting ATT permission');
			requestConsent().catch((error) => {
				console.error('ATTConsentGate: Error requesting ATT permission:', error);
			});
		}
	}, [consent, requestConsent]);

	return null;
};

